import { render, staticRenderFns } from "./ExtraFields.vue?vue&type=template&id=1a8168de&"
import script from "./ExtraFields.vue?vue&type=script&lang=js&"
export * from "./ExtraFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports